import Link from "next/link";
import React from "react";

export default function Logo() {
  return (
    <Link href="/" className="flex items-center no-underline ml-2 gap-2">
      <span
        style={{
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          fontSize: '24px',
          fontWeight: 700,
          letterSpacing: '2px',
        }}
      >
        <span style={{ color: '#F97316' }}>REAL</span>
        <span style={{ color: '#ffffff' }}>-IQ</span>
      </span>
    </Link>
  );
}
